/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityZoneType } from '../../models/facility-zone-type';

export interface DeleteFacilityZoneType$Params {
  facilityZoneTypeId: number;
}

export function deleteFacilityZoneType(http: HttpClient, rootUrl: string, params: DeleteFacilityZoneType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityZoneType>> {
  const rb = new RequestBuilder(rootUrl, deleteFacilityZoneType.PATH, 'delete');
  if (params) {
    rb.path('facilityZoneTypeId', params.facilityZoneTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityZoneType>;
    })
  );
}

deleteFacilityZoneType.PATH = '/api/facilityzonetype/{facilityZoneTypeId}';
